import { AppStore } from "@/store/AppStore";
import { Dexie } from "dexie";

export const searchUploadedFileBatches = async ({
  store,
}: {
  store: AppStore;
}): Promise<string[]> => {
  // Get all uploaded file batches from the local table
  const keys = await store.uploadedFileBatches.localTable
    .where("model_id")
    .between(Dexie.minKey, Dexie.maxKey)
    .keys();

  return keys as unknown as string[];
};
